import React from "react";
import { useSelector } from "react-redux";
import InstantWinPrizeTableComponent from "./instantWinPrizeTable.component";

export default function InstantWinPrizeTableContainer({ tableData }) {
  const lang = useSelector((state) => state.constant.languages);

  return <InstantWinPrizeTableComponent tableData={tableData} lang={lang} />;
}
